import React from 'react';
import styles from './Messages.module.css'; 
import { useAuth } from '../../../../context/AuthContext';  
import Chat from '../../../Functionality/Chat/Chat';
import AdminChat from '../../../Functionality/Chat/AdminChat'; 

function Messages() {
  const { user } = useAuth();  

  if (!user) {
    return <div>Loading user data...</div>;
  }

  const ChatComponent = user.role === 'admin' ? AdminChat : Chat;

  return (
    <div className={styles.container}>
        <div className={styles.title}>Contact Us</div>
        <div className={styles.title}>Welcome {user?.fname}</div> {/* Displaying the first name */}
        <div className={styles.itemThree}><ChatComponent user={user}  userId={user?.user_id} /></div> {/* Passing user info to Chat */}
        <div className={styles.itemFour}>Something Here</div>
    </div>
  );
}

export default Messages;
